<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="157" height="158" viewBox="0 0 157 158" fill="none">
        <g filter="url(#filter0_d_2043_542)">
            <path d="M58.5 79C58.5 67.9543 67.4543 59 78.5 59V59C89.5457 59 98.5 67.9543 98.5 79V79C98.5 90.0457 89.5457 99 78.5 99V99C67.4543 99 58.5 90.0457 58.5 79V79Z" fill="white"/>
        </g>
        <defs>
            <filter id="filter0_d_2043_542" x="0.400002" y="0.900002" width="156.2" height="156.2" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset/>
            <feGaussianBlur stdDeviation="29.05"/>
            <feComposite in2="hardAlpha" operator="out"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2043_542"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2043_542" result="shape"/>
            </filter>
        </defs>
    </svg>
</template>